import SAPOMailConfig          from "@/SAPOMailConfig";
import NotificationsController from "./Notifications/NotificationsController";
import DomController           from '@/js/Webmail/DomController';

export { AccountControllerSingleton as default };

/**
* Account Controller
*
* @author      fheitor <fabio-h-nascimento@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/

class AccountController {
  /**
   * Account Alias
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  account = {};

  /**
   * Maps account params
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  mapAccount() {
    this.account = SAPOMailConfig.server.account;

    this.account.premium = {
      enabled : SAPOMailConfig.server.account.cos.premium_eligibility === 'PREMIUM'         ? true : false,
      allowed : SAPOMailConfig.server.account.cos.premium_eligibility === 'PREMIUM_ALLOWED' ? true : false,
    }

    this.account.premium.upgrade = this.account.premium.enabled === false && this.account.premium.allowed === true;
    this.account.premium.visible = this.account.premium.enabled === true || this.account.premium.allowed === true;

    this.account.cos.quota_size         = this.account.cos.quota_size / (1024 * 1024 * 1024);
    this.account.cos.virtual_quota_size = this.account.cos.virtual_quota_size / (1024 * 1024 * 1024);
  }
  
  showAds(provider, folder_id) {
      if(
      !this.isAdProviderEnabled(provider) ||
      !this.isAdProviderAllowedInCurrentFolder(provider, folder_id)) {
          return false;
      }
      return true;
  }
    
  isAdProviderEnabled = (provider) => {
      if (!SAPOMailConfig.server.ads || !SAPOMailConfig.server.ads[provider]) {
            return false;
      }
      
      if (SAPOMailConfig.server.ads[provider].enabled && SAPOMailConfig.server.ads[provider].enabled  === false) {
          DomController.removeBodyClass('hasPub');
      }
      
      return SAPOMailConfig.server.ads[provider].enabled;
  };
    
  isAdProviderAllowedInCurrentFolder = (provider, folder_id) => {
      if (!SAPOMailConfig.server.ads || !SAPOMailConfig.server.ads[provider] || !SAPOMailConfig.server.ads[provider].disabled_on) {
            return false;
      }
      
      if (SAPOMailConfig.server.ads[provider].enabled && SAPOMailConfig.server.ads[provider].enabled  === false) {
          DomController.removeBodyClass('hasPub');
      }
      
      return !SAPOMailConfig.server.ads[provider].disabled_on.includes(folder_id);
  };

  /**
   * Adds notifications
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  addNotifications() {
    if (this.account.has_recover === false) {
      NotificationsController.addWarning('user_dashboard.recover_warning_1', "", {
        zones: ['user_dashboard'],
        auto_dismiss: false,
        message_type: "text_link",
        link_text: 'user_dashboard.recover_warning_2',
        link_icon: 'fas fa-external-link-alt',
        link_class: 'link',
        link_type: 'external',
        link: 'user_dashboard.links.manage_recover',
      });
    }
  }

  /**
   * Returns if email is an account alias
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  isAlias(email) {
    return this.account.alias.indexOf(email) === -1 ? false : true;
  }

  /**
   * Returns account alias
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Array}
   */
  getAlias() {
    return this.account.alias || [];
  }

  /**
   * Returns account identities
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Array}
   */
  getIdentities() {
    return this.account.identities || [];
  }

  /**
   * Returns account message options
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Object}
   */
  getMessageOptions() {
    return this.account.message_options || {};
  }

  /**
   * Checks if account has permissions
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Boolean}
   */
  checkPermissions(type, permission) {
    if (type === 'kids') {
      return this.hasKidsPermissions();
    }

    if (type === 'premium') {
      return this.hasPremiumPermissions();
    }

    if (type === 'cos') {
      return this.hasCosPermissions(permission);
    }

    return false;
  }

  hasKidsPermissions() {
    return this.account.kids.is_kid;
  }

  hasCosPermissions(permission) {
    return (this.account.cos[permission] && this.account.cos[permission] > 0) ? true : false;
  }

  hasPremiumPermissions() {
    return this.account.premium.enabled || this.account.premium.allowed;
  }

}

const AccountControllerSingleton = new AccountController();
